// React
import { PropsWithChildren, createContext } from "react"

// Types
import type { ReturnMasterType } from "../types"

// Utils
import { defaultMasterData, useMasterData } from "../utils"

export const MasterContext = createContext<ReturnMasterType>({
  data: defaultMasterData,
  isError: false,
  isLoading: false,
  appendData(_field, _value) {}
})

export function MasterProvider(params: PropsWithChildren<{}>): JSX.Element {
  // Hooks
  const masterData = useMasterData()

  return (
    <MasterContext.Provider value={masterData}>
      {params.children}
    </MasterContext.Provider>
  )
}
